export class User {

  public userID: number;
  public roleID: string;
  public firstName: string;
  public lastName: string;
  public email: string;
  public address1: string;
  public address2: string;
  public zip: string;
  public city: string;
  public stateID: string;

  public dateOfBirth: any;
  public gender: string;
  public phone: string;
  public imagePath: string;

  public countryName: string;
  public roleName: string;
  public stateName: string;

  public countryID: string;
  public isActive: boolean;
  public userName: string;
  public password: string;
  public confirmPassword: string;
  public fullName: string;
  //public CountryModel Country
  //public ICollection < Order > Orders
  //public StateModel State { get; set; }
  //public ICollection < UserRoleAssociationModel > UserRoleAssociations

}



// WEBPACK FOOTER //
// ./src/app/models/user/user-model.ts